import { Collapse, TableCell, TableRow } from '@material-ui/core';
import moment from 'moment';
import 'moment/min/locales';
import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import Security from '../../commons/security/Security.js';
import { StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles';
import * as ESTADOS from '../../commons/constants/formularioRecurrenciaEstado.js';

const FormularioRecurrenciaGridRow = (props) => {
  const formularioRecurrencia = props.formularioRecurrencia;
  const baseUrl = props.baseUrl;
  const [redirectTo, setRedirectTo] = useState(null);

  const getEstado = () => {
    switch (formularioRecurrencia.estado) {
      case ESTADOS.ID_OK:
        return 'status-green';
      case ESTADOS.ID_VENCIDO:
        return 'status-red';
      case ESTADOS.ID_PENDIENTE:
        return 'status-yellow';
      default:
        return 'status-grey';
    }
  };

  return (
    <>
      {redirectTo && <Redirect push to={redirectTo} />}
      <TableRow>
        <StyledTableCell align="left">{formularioRecurrencia.centro_costos.nombre}</StyledTableCell>
        <StyledTableCell align="left"
          className={getEstado()}>
        </StyledTableCell>
        <StyledTableCell align="left">{formularioRecurrencia.tipo_formulario.nombre}</StyledTableCell>
        <StyledTableCell align="left">{formularioRecurrencia.descripcion}</StyledTableCell>
        <StyledTableCell align="left">
          {formularioRecurrencia.fecha_vencimiento ? moment(formularioRecurrencia.fecha_vencimiento).format('DD/MM/YYYY') : ''}
        </StyledTableCell>
        {props.columnsEnabled.transportadora ?
          <StyledTableCell align="left">
            {formularioRecurrencia.entidad.transportadora_eloquent ? formularioRecurrencia.entidad.transportadora_eloquent.nombre : ''}
          </StyledTableCell>
          : null
        }
        <StyledTableCell>
          <div className="d-inline-flex">
            {Security.hasPermission('FORMULARIO_RECURRENCIA_VISUALIZAR') ?
              <button
                className="action view btn btn-sm btn-icon btn-dt-grid text-success"
                data-title="Ver"
                data-togle="tooltip"
                data-placement="top"
                onClick={() => setRedirectTo(baseUrl + '/' + formularioRecurrencia.id)}
              >
                <i className="fa fa-search fa-xs" />
              </button>
            : ''}
            {Security.hasPermission('FORMULARIO_RECURRENCIA_MODIFICAR') ?
              <button
                className="action edit btn btn-sm btn-icon btn-dt-grid text-success"
                data-title="Editar"
                data-togle="tooltip"
                data-placement="top"
                onClick={() => setRedirectTo(baseUrl + '/' + formularioRecurrencia.id + '/edit')}
              >
                <i className="fa fa-pencil fa-xs" />
              </button>
            : ''}
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
};

export default FormularioRecurrenciaGridRow;
